if (document.querySelector(".counters")) {
  const observeCount = function(element) {
    try {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
         
          if (entry.isIntersecting) {
            let { target } = entry;
            let { number } = target.dataset;
            let od = new Odometer({
              el: target,
              value: 0,
              duration: 330,
              format: "(,ddd)",
              theme: "default",
            });
            setTimeout(function() {
              target.innerHTML = number;
            }, 200);
          }
        });
      });

      observer.observe(element);
    } catch (Exception) {
      console.warn("Exception in observeCount => " + Exception);
    }
  };

  let counters = document.querySelectorAll(".counters");
  counters.forEach((item) => observeCount(item));
}
